import { createFileRoute, Outlet } from '@tanstack/react-router'
import { subscriptionQueryOptions } from 'hooks/api/subscriptions'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId')({
  component: Outlet,
  loader: ({ context: { queryClient, buildRequest }, params: { subscriptionId } }) => {
    queryClient.prefetchQuery(subscriptionQueryOptions(buildRequest, subscriptionId, []))
  },
})
